import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as TrashSvg } from './assets/trash.svg';

const TrashIcon = React.forwardRef((args, ref) => <SvgIcon component={TrashSvg} ref={ref} {...args} />);

export default TrashIcon;
